import React, { useEffect, useState } from 'react';
import { adminApi } from '../services/api';

export default function AdminQuarantine() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = () => {
    setLoading(true);
    adminApi.quarantine()
      .then((r) => setRows(r.rows || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const resolve = async (bccId, action) => {
    const contactId = action === 'match' ? window.prompt('CRM Contact ID to attach to:') : null;
    if (action === 'match' && !contactId) return;
    try { await adminApi.resolveQuarantine(bccId, action, contactId); load(); } catch (err) { alert(err.message); }
  };

  if (loading) return <div className="card"><span className="spinner" /></div>;
  if (error) return <div className="card"><span className="badge danger">Error</span> {error}</div>;

  return (
    <div className="stack-lg">
      <h1 className="h1">BCC Quarantine ({rows.length} open)</h1>
      {rows.length === 0 ? <div className="card muted">No open quarantine rows.</div> : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr><th>Received</th><th>From</th><th>Subject</th><th>Snippet</th><th></th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.ROWID}>
                  <td className="small">{r.receivedAt ? new Date(r.receivedAt).toLocaleString() : '—'}</td>
                  <td className="small">{r.fromEmail}</td>
                  <td className="small">{r.subject}</td>
                  <td className="small muted" style={{ maxWidth: 320 }}>{(r.bodySnippet || '').slice(0, 200)}</td>
                  <td>
                    <button className="btn ghost small" onClick={() => resolve(r.ROWID, 'match')}>Match</button>
                    <button className="btn ghost small" onClick={() => resolve(r.ROWID, 'discard')}>Discard</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
